import { forwardRef } from 'react'
import { FieldIcon } from 'apps/studio/components/shared/FieldIcon'
import { generateStyles } from 'apps/studio/components/pdfViewer/elements/PdfElement'

const ELEMENT_OVERLAY_TYPES = ['dataInput', 'pageElement', 'table', 'tableMove']

const resolveOverlay = ({
  type,
  data,
  positionDefault,
  stylesDefault,
}) => {
  if (type === 'tableMove') {
    const { width = 0, height = 0 } = data.tableLayout?.position || {}
    return { width, height, iconType: 'Static Table', label: 'Static Table' }
  }
  if (type === 'table') {
    return {
      width: data.tablePosition?.width ?? positionDefault.width,
      height: data.tablePosition?.height ?? positionDefault.height,
      iconType: 'Static Table',
      label: 'Static Table',
    }
  }
  const { entryData, element } = data
  const isPageElement = type === 'pageElement'
  return {
    width: isPageElement ? element.position.width : positionDefault.width,
    height: isPageElement ? element.position.height : positionDefault.height,
    styles: isPageElement
      ? element.styles
      : generateStyles({ position: positionDefault, style: stylesDefault }),
    iconType: isPageElement ? element.element_type : entryData.type,
    label: isPageElement ? element.label : `New ${entryData.type}`,
  }
}

export const ElementOverlay = forwardRef(
  ({ activeDraggable, positionDefault, stylesDefault, scaleFactor }, ref) => {
    const data = activeDraggable?.data?.current
    if (!data || !ELEMENT_OVERLAY_TYPES.includes(data.type)) return null

    const { width, height, styles, iconType, label } = resolveOverlay({
      type: data.type,
      data,
      positionDefault,
      stylesDefault,
    })

    return (
      <div
        className="page-element element--is-dragging"
        ref={ref}
        style={{
          ...styles,
          width: width * scaleFactor,
          height: height * scaleFactor,
          '--scale-factor': scaleFactor,
        }}
      >
        <div className="element--label workspace-element--label">
          <FieldIcon type={iconType} />
          <span className="element--label-name">{label}</span>
        </div>
      </div>
    )
  }
)
